import { Image } from '@chakra-ui/react';
import { THealthDomain } from '@/types/Health.types';

// White domain glyph for a pill. The domain artwork ships purple/grey only, so the same
// brightness(0) + invert(1) recolour used by the loop's domain tiles turns it white.
export const domainGlyph = (domain: THealthDomain, size = 16) => (
  <Image
    src={`/svg/domains/icon-${domain}.svg`}
    alt=""
    width={`${size}px`}
    height={`${size}px`}
    objectFit="contain"
    sx={{ filter: 'brightness(0) invert(1)' }}
  />
);
